export const legalPages = {
  about: {
    path: "/about",
    title: "من نحن",
    eyebrow: "WS Winner",
    description:
      "تعرف على WS Winner ورؤيتنا في تقديم منتجات مكملات غذائية مختارة بعناية وتجربة تسوق واضحة وموثوقة.",
    intro:
      "نحن في WS Winner نعمل على توفير منتجات مكملات غذائية عالية الجودة مع تجربة شراء سهلة، ومعلومات واضحة، ودعم قريب من العميل قبل وبعد الطلب.",
    sections: [
      {
        heading: "رسالتنا",
        body: "نسعى إلى مساعدة العملاء على اختيار المنتجات المناسبة بثقة من خلال عرض تفاصيل المنتجات بوضوح، وتسهيل عملية الطلب، والالتزام بخدمة عملاء مهنية.",
      },
      {
        heading: "ما نقدمه",
        items: [
          "منتجات مختارة بعناية ضمن فئات المكملات الغذائية.",
          "تجربة تسوق بسيطة وآمنة من التصفح حتى الدفع.",
          "تواصل مباشر مع فريق الدعم للاستفسارات المتعلقة بالطلبات والمنتجات.",
        ],
      },
      {
        heading: "تنبيه صحي",
        body: "المعلومات المعروضة على الموقع لا تعد بديلا عن الاستشارة الطبية. يرجى مراجعة مختص صحي قبل استخدام أي منتج، خصوصا في حالات الحمل أو الرضاعة أو الأمراض المزمنة أو استخدام الأدوية.",
      },
    ],
  },
  disclaimer: {
    path: "/disclaimer",
    title: {
      ar: "إرشادات التوجيه الصحي والتوعية",
      en: "Health Guidance & Educational Disclaimer",
    },
    eyebrow: "WS Winner",
    description: {
      ar: "توضيح لمفهوم التدريب ونطاق التوجيه الغذائي لضمان تجربة صحية آمنة وموثوقة.",
      en: "A clear overview of our coaching scope to ensure a safe, supportive, and trusted health journey.",
    },
    intro: {
      ar: "نهتم برحلتك الصحية، ولأن نجاحك يبنى على أسس واضحة، يرجى قراءة نطاق التدريب التوعوي التالي قبل البدء.",
      en: "Your health journey matters to us. To build a transparent and successful partnership, please review our coaching scope below.",
    },
    sections: [
      {
        heading: {
          ar: "رؤيتنا ونطاق التوجيه الصحي",
          en: "Our Approach & Coaching Scope",
        },
        body: {
          ar: "يسعدنا مرافقتك كمدرب تغذية معتمد من المستوى الأول (Level 1) من مؤسسة Precision Nutrition العالمية. نركز في برامجنا على الجانب التوعوي والتعليمي لتطوير نمط حياتك وعاداتك اليومية بشكل إيجابي ومستدام. يرجى العلم بأن دورنا مكمل للرعاية الطبية وليس بديلاً عنها، حيث أن المدرب لا يقدم تشخيصات، أو بروتوكولات علاجية، أو خططاً طبية بديلة عن استشارات الأطباء المرخصين أو أخصائيي التغذية العلاجية.",
          en: "We are thrilled to guide you as a Precision Nutrition Level 1 Certified Coach. Our focus is purely educational and lifestyle-driven—helping you build sustainable, positive habits. Please note that our guidance is designed to complement, not replace, clinical medical care. Your coach does not issue diagnoses, prescribe medical treatments, or act as a substitute for your licensed medical doctor or clinical registered dietitian.",
        },
      },
      {
        heading: {
          ar: "طبيعة البرنامج والمقترحات",
          en: "Program Nature & Suggestions",
        },
        body: {
          ar: "جميع المقترحات والمعلومات المقدمة حول نمط الحياة والمكملات الغذائية هي لأغراض تعليمية وتثقيفية فقط، لمساعدتك على فهم خياراتك الصحية وتحسين جودة حياتك اليومية.",
          en: "All lifestyle, dietary, and supplement suggestions shared in this program are entirely educational. They are crafted to help you understand your wellness options and elevate your daily quality of life.",
        },
      },
      {
        heading: {
          ar: "التعاون المشترك والمسؤولية",
          en: "Shared Collaboration & Wellness Rights",
        },
        items: {
          ar: [
            "المعلومات المتوفرة صُممت لتدعم وعيك الصحي ولا تغني عن استشارة طبيبك الخاص.",
            "نشجعك دائماً على مشاركة نظام مكملاتك الجديد مع طبيبك المعالج لضمان تناسبه الكامل مع حالتك.",
            "يتولى المشترك بوعي ومسؤولية إدارة قراراته الصحية وتطبيق الإرشادات بما يناسب جسمه.",
          ],
          en: [
            "Our materials are designed to empower your wellness knowledge and do not replace professional medical checkups.",
            "We encourage you to share your new supplement regimen with your doctor to ensure it aligns with your medical history.",
            "The client thoughtfully manages their wellness choices and application in a way that best serves their individual body.",
          ],
        },
      },
    ],
  },
  certification: {
    path: "/certification-details",
    title: {
      ar: "حول شهادة مدرب التغذية (Level 1)",
      en: "About Level 1 Nutrition Certification",
    },
    eyebrow: "Precision Nutrition (PN1)",
    description: {
      ar: "تعرف على خلفية مدربك والمنهجية العلمية المعتمدة عالمياً وراء توجيهاتنا الغذائية.",
      en: "Learn about your coach's background and the globally respected scientific framework behind our nutrition guidance.",
    },
    intro: {
      ar: "مؤسسة Precision Nutrition هي الهيئة الرائدة عالمياً في مجال التغذية العملية وتعديل السلوك اليومي، وتعتمد برامجها على أحدث الأبحاث العلمية لمساعدة الأفراد في الوصول لأهدافهم الصحية بشكل مستدام وعملي.",
      en: "Precision Nutrition is the world's leading body in practical nutrition and behavior change science. Their programs rely on evidence-based research to help people reach health goals sustainably.",
    },
    sections: [
      {
        heading: {
          ar: "ماذا تعني شهادة المستوى الأول (PN1)؟",
          en: "What is the Level 1 (PN1) Certification?",
        },
        body: {
          ar: "شهادة المستوى الأول تعني أن المدرب مؤهل ومدرّب بشكل احترافي لمساعدتك على تغيير عاداتك الغذائية ونمط حياتك بشكل تدرجي ومستدام، بالاعتماد على علوم الكيمياء الحيوية السلوكية وعلم التغذية التطبيقي، وليس مجرد تقديم جداول طعام عشوائية.",
          en: "The Level 1 credential means your coach is professionally trained to help you modify dietary and lifestyle habits progressively. It focuses on nutritional science and behavior-change psychology rather than just generic diet templates.",
        },
      },
      {
        heading: {
          ar: "الركائز الأساسية للتوجيه",
          en: "Core Pillars of Guidance",
        },
        items: {
          ar: [
            "تطبيق التغذية القائمة على الأدلة والبراهين العلمية الحديثة.",
            "التركيز على بناء عادات يومية مرنة تناسب ظروف حياتك الخاصة.",
            "فهم احتياجات الجسم من المغذيات الكبرى والدقيقة والمكملات الآمنة.",
            "تطوير علاقة صحية وإيجابية مع الطعام بعيداً عن الحرمان الحاد.",
          ],
          en: [
            "Application of modern, evidence-based nutritional science.",
            "Focus on developing highly flexible daily habits tailored to your life.",
            "Understanding macronutrient, micronutrient, and safe supplement needs.",
            "Fostering a positive, sustainable relationship with food without extreme restriction.",
          ],
        },
      },
      {
        heading: {
          ar: "الحدود القانونية والطبية",
          en: "Legal & Medical Boundaries",
        },
        body: {
          ar: "من المهم معرفة أن هذه الشهادة تركز على التثقيف الغذائي ونمط الحياة الصحي. لا يقوم مدرب PN1 بتشخيص الأمراض، ولا يصف بروتوكولات علاجية للمرضى، ولا يحل محل الطبيب البشري أو أخصائي التغذية العلاجية في المستشفيات.",
          en: "It is important to know that this certification focuses on nutritional education and lifestyle enhancement. A PN1 coach does not diagnose conditions, prescribe medical treatment protocols, or replace a clinical dietitian or medical doctor.",
        },
      },
    ],
  },
  terms: {
    path: "/terms",
    title: "شروط الاستخدام",
    eyebrow: "الشروط والأحكام",
    description:
      "الشروط العامة التي تنظم استخدام موقع WS Winner وعمليات الشراء والخدمات المتاحة.",
    intro:
      "باستخدامك لموقع WS Winner أو إتمام أي طلب، فإنك توافق على الالتزام بهذه الشروط. يرجى قراءة البنود بعناية قبل استخدام الموقع.",
    sections: [
      {
        heading: "استخدام الموقع",
        items: [
          "يجب استخدام الموقع لأغراض قانونية وشخصية فقط.",
          "يحظر إساءة استخدام الموقع أو محاولة تعطيل خدماته أو الوصول غير المصرح به لأي جزء منه.",
          "قد نقوم بتحديث محتوى الموقع أو سياساته عند الحاجة دون إشعار مسبق.",
        ],
      },
      {
        heading: "الطلبات والدفع",
        items: [
          "يتم تأكيد الطلب بعد اكتمال البيانات المطلوبة ونجاح عملية الدفع عند الحاجة.",
          "قد نرفض أو نلغي أي طلب في حال وجود خطأ في البيانات أو توفر المنتج أو الاشتباه في استخدام غير مشروع.",
          "تخضع الأسعار والعروض للتحديث، والسعر المعتمد هو الظاهر وقت إتمام الطلب.",
        ],
      },
      {
        heading: "معلومات المنتجات",
        body: "نحرص على دقة المعلومات المعروضة، لكن قد تختلف العبوات أو تفاصيل المنتج بحسب المورد أو بلد المنشأ. لا نضمن أن جميع المعلومات تخلو تماما من الأخطاء غير المقصودة.",
      },
    ],
  },
  privacy: {
    path: "/privacy-policy",
    title: "سياسة الخصوصية",
    eyebrow: "حماية البيانات",
    description:
      "تعرف على كيفية جمع واستخدام وحماية البيانات الشخصية عند استخدام موقع WS Winner.",
    intro:
      "خصوصيتك مهمة لنا. توضح هذه السياسة نوع البيانات التي قد نجمعها وكيف نستخدمها لتحسين الخدمة وتنفيذ الطلبات والتواصل معك.",
    sections: [
      {
        heading: "البيانات التي نجمعها",
        items: [
          "بيانات الحساب والتواصل مثل الاسم والبريد الإلكتروني ورقم الهاتف.",
          "بيانات الطلب والشحن مثل العنوان والمنتجات المطلوبة وحالة الدفع.",
          "بيانات تقنية تساعدنا على تحسين أداء الموقع وتجربة الاستخدام.",
        ],
      },
      {
        heading: "كيفية استخدام البيانات",
        items: [
          "معالجة الطلبات وترتيب الشحن والتواصل بخصوص حالة الطلب.",
          "تقديم الدعم والرد على الاستفسارات.",
          "تحسين خدمات الموقع والحد من الاحتيال أو إساءة الاستخدام.",
        ],
      },
      {
        heading: "مشاركة البيانات",
        body: "قد نشارك البيانات الضرورية فقط مع مزودي خدمات الدفع أو الشحن أو الدعم الفني بما يلزم لتنفيذ الخدمة. لا نبيع بياناتك الشخصية لأطراف خارجية.",
      },
    ],
  },
  shipping: {
    path: "/shipping-policy",
    title: "سياسة الشحن والتوصيل",
    eyebrow: "الطلب والشحن",
    description:
      "قواعد الشحن العامة لدى WS Winner، بما في ذلك مدة وصول الطلب خلال 14 يوما.",
    intro:
      "نلتزم بتجهيز الطلبات وشحنها بأفضل صورة ممكنة. تطبق القواعد التالية على الشحن ما لم يتم توضيح خلاف ذلك أثناء إتمام الطلب.",
    sections: [
      {
        heading: "مدة التوصيل",
        body: "تصل الطلبات عادة خلال مدة أقصاها 14 يوما من تاريخ تأكيد الطلب، وقد تختلف المدة بحسب المدينة، شركة الشحن، العطلات الرسمية، أو الظروف الخارجة عن إرادتنا.",
      },
      {
        heading: "تجهيز الطلب",
        items: [
          "يبدأ تجهيز الطلب بعد تأكيد بيانات العميل وتوفر المنتجات.",
          "قد يتم التواصل مع العميل لتأكيد العنوان أو أي معلومات ناقصة قبل الشحن.",
          "في حال تعذر التوصيل بسبب بيانات غير صحيحة، قد يتحمل العميل أي رسوم إضافية لإعادة الشحن.",
        ],
      },
      {
        heading: "متابعة الشحنة",
        body: "عند توفر رقم تتبع من شركة الشحن، سيتم تزويد العميل به عبر وسائل التواصل المتاحة في الطلب. يمكن التواصل معنا عند وجود أي تأخير يتجاوز المدة المتوقعة.",
      },
    ],
  },
  returns: {
    path: "/returns-policy",
    title: "سياسة الاسترجاع والاستبدال",
    eyebrow: "ما بعد الطلب",
    description:
      "القواعد العامة للاستبدال والتعامل مع المشكلات المتعلقة بالطلبات في WS Winner.",
    intro:
      "نحرص على تقديم منتجات عالية الجودة، ونلتزم بضوابط السلامة والجودة الخاصة بالمنتجات القابلة للاستهلاك.",
    sections: [
      {
        heading: "سياسة الاسترجاع",
        body: "نظراً لطبيعة المنتجات القابلة للاستهلاك وشحنها من مستودعات خارج الشرق الاوسط، لا نقبل إرجاع المنتجات أو استرداد قيمتها بعد إتمام الشراء واستلام الطلب.",
      },
      {
        heading: "المنتجات التالفة أو الخاطئة",
        body: "إذا وصل المنتج تالفاً أو معيباً أو مختلفاً عن الطلب، يرجى التواصل مع فريق الدعم خلال 48 ساعة من استلام الشحنة مع إرفاق صور واضحة للمنتج والعبوة ورقم الطلب لمراجعة الحالة.",
      },
      {
        heading: "الاستبدال",
        body: "بعد مراجعة الحالة والتأكد من وجود تلف أو عيب أو خطأ في الطلب، سيتم إرسال منتج بديل دون الحاجة إلى إعادة المنتج المتضرر، وذلك وفقاً لتقدير فريق الدعم.",
      },
      {
        heading: "الحالات غير المشمولة",
        items: [
          "تغيير الرأي بعد الشراء.",
          "عدم الرغبة في المنتج بعد استلامه.",
          "المنتجات المفتوحة أو المستخدمة.",
          "الأضرار الناتجة عن سوء الاستخدام أو سوء التخزين بعد الاستلام.",
        ],
      },
    ],
  },
};

export const footerLegalGroups = {
  important: [legalPages.about, legalPages.disclaimer],
  order: [legalPages.shipping, legalPages.returns],
  policies: [legalPages.terms, legalPages.privacy],
};
